import script from "./NotFoundPage.vue?vue&type=script&setup=true&lang=js"
export * from "./NotFoundPage.vue?vue&type=script&setup=true&lang=js"

import "./NotFoundPage.vue?vue&type=style&index=0&id=6203ea0c&scoped=true&lang=css"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6203ea0c"]])

export default __exports__